import React, { useCallback } from "react";
import cls from "../style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useMemo } from "react";
import { ORDER_RETURN_REQUESTED, ORDER_RETURN_REFUND_REQUESTED, ORDER_RETURN_CANCELED } from "../../../../../../utils/constant";
import OrderItemProductImages from '../fragments/product-images/index';
import OrderItemPrices from "../fragments/order-item-prices";
import { Link } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";
import ConfigConfirm from "../../../../../../../../components/alert/config-confirm";
import { fetchCancelReturnOrder } from "../../../../../../../../../api";
import { useSelector, useDispatch } from "react-redux";
import { setOrderListReturn, action_fetch_order_return_detail, setCustomerLoading } from "../../../../../../../../../store/actions/pages/customer";
import { useEffect } from "react";


export const OrderReturnStatusBtnLink = props =>{
    useStyles(cls);
    const {  orderItem, isDetail } = props;
    const Intl = useIntl();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { orderListReturn } = pageCustomer;
    const dispatch = useDispatch();

    const cancelReturnOrder = useCallback((returnId) =>{
        ConfigConfirm({
            boxStyle:{
            },
            message:{
                text: Intl.formatMessage({ id: "are_you_want_cancel_return", defaultMessage: "Are you sure you want to cancel the return?" }),
                style:{},
            },
            btn1:{
                clickHandle:async () =>{
                    dispatch(setCustomerLoading(true));
                    let response = await fetchCancelReturnOrder(returnId);
                    if(response?.code === 200){
                        let orders = orderListReturn?.data?.map((item)=>{
                            if(item?.id === returnId){
                                return { ...item, status: ORDER_RETURN_CANCELED }
                            }else{
                                return item;
                            }
                        });

                        dispatch(setOrderListReturn({data: orders}));

                        if(isDetail){
                            dispatch(action_fetch_order_return_detail(returnId));
                        }
                    }
                    dispatch(setCustomerLoading(false));
                }
            },
            btn2:{
            }
        });
    }, [orderListReturn]);

    const returnReceiptFont = useMemo(() =>{
        if(orderItem?.status === ORDER_RETURN_REQUESTED && orderItem?.logistics){
            return Intl.formatMessage({ id: "edit_return_receipt", defaultMessage: "Edit Return Receipt" });
        }else{
            return Intl.formatMessage({ id: "return_receipt", defaultMessage: "Return Receipt" });
        }
    }, [orderItem]);

    return <div className={`${cls.OrderStatusBtnLink} ${cls.OrderReturnStatusBtnLink}`}>
        {
            orderItem?.status === ORDER_RETURN_REQUESTED && <React.Fragment>
                <a 
                    className={cls.LinkBtn} 
                    onClick={() =>cancelReturnOrder(orderItem.id)}
                >   
                    <FormattedMessage id="cancel_return" defaultMessage="Cancel Return" />
                </a>

                <Link 
                    to={`/user/order/return-logistics/${orderItem?.id}`}
                    className={cls.LinkBtn} 
                >
                    {returnReceiptFont}
                </Link>
            </React.Fragment>
        }
    </div>
}

const OrderReturnItem = props =>{
    useStyles(cls);
    const { returnOrderItem } = props;

    const orderStatus = useMemo(() =>{
        if(returnOrderItem?.status === ORDER_RETURN_REQUESTED){
            return "Return Requested";
        }else if(returnOrderItem?.status === ORDER_RETURN_REFUND_REQUESTED){
            return "Refund Requested";
        }else if(returnOrderItem?.status === ORDER_RETURN_CANCELED){
            return "Return Canceled";
        }else{
            return "Refunded";
        }
    }, [returnOrderItem]);

    return <div className={cls.OrderListItem}>
        <div className={cls.Hd}>
            <div className={cls.OrderNoStatus}>
                <span></span>

                <span>{orderStatus}</span>
            </div>
        </div>

        <div className={cls.PaddingContainer}>
            <OrderItemProductImages isReturn orderItem={returnOrderItem} orderProducts={returnOrderItem?.returnOrderItems} />

            <OrderItemPrices orderItem={returnOrderItem} orderProducts={returnOrderItem?.returnOrderItems} priceTotal={returnOrderItem?.refundTotal} />

            <OrderReturnStatusBtnLink orderItem={returnOrderItem} />
        </div>
    </div>
}

export default OrderReturnItem;